import {Button, Alert, Stack, Box, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, CircularProgress, TextField, InputAdornment} from '@mui/material';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import Tip from '../../Tools/Tip';
import { Tags as API } from '../../../services/API/Tags';
import Layout from "../../../components/Frames/Layout"
import TagTypeSelect from './TagTypeSelect';
import Confirm from '../../Tools/Confirm';
import DisciplineForm from './DisciplineForm';
import Chip from '../../Tools/Chip';
import { Link } from 'react-router-dom';
import useJsonStore from '../../../services/Hooks/useJsonStore';

export default function List(){

    const [error, setError] = useState(false)
    const [items, setItems] = useState(null)
    const [deleteConfirm, setDeleteConfirm] = useState(false)
    const step = 25;
    const [limit, setLimit] = useState(25)
    const [add, setAdd] = useState(false)

    const [search, setSearch] = useState({fast: '', type: 'discipline'})

    const store = useJsonStore();

    useEffect(() => {

        API.getAll()
            .then(r => setItems(r.data))
            .catch(e => setError(true))

        if( store.has('tagSearch') ) setSearch( store.get('tagSearch') )

    }, [store])

    const handleSearch = (key, val) => {
        let copy = {...search};
        copy[key] = val;
        store.set('tagSearch', copy);
        return setSearch(copy);
    }

    const handleDelete = () => {
        const id = deleteConfirm;

        let copy = [...items];
        copy = copy.filter(i => i.id !== id);

        API.delete(id)
            .then(r => console.log(r.data))
            .catch(e => setItems([...items]))

        setDeleteConfirm(false);
        return setItems(copy);
    }

    const match = i => {
        return i.title.toLowerCase().includes(search.fast) && 
            (search.type === 'all' || search.type === i.type?.id)
    }

    const sortText = i => i.type.rank + '.' + i.title.toLowerCase();

    const list = (items || [])
        .filter(i => match(i))
        .sort((a,b) => sortText(a) > sortText(b) ? 1 : -1);

    
    const handleAdd = item => {
        const copy = [...items];
        copy.push(item);
        return setItems(copy);
    }


    return <Layout title="Mots clés" tab="tags" menu="admin">

        <Stack direction='row' justifyContent='space-between' alignItems='center' style={{margin: '10px 0px', flexWrap: 'wrap'}}>

            {!add ? <>
                    <Stack direction='row' style={{flexWrap: 'wrap'}}>
                        <Box width="250px" style={{margin: '5px'}}>
                            <TextField
                                label='Mot clé'
                                type='search'
                                size='small'
                                value={search.fast || ''}
                                onChange={e => handleSearch('fast', e.target.value.toLowerCase())}
                                InputProps={{
                                    startAdornment: <InputAdornment position='start'><SearchIcon/></InputAdornment>
                                }}
                                fullWidth
                            />
                        </Box>

                        <Box width="250px" style={{margin: '5px'}}>
                            <TagTypeSelect 
                                value={search.type}
                                onChange={t => handleSearch('type', t)}
                            />
                        </Box>

                    </Stack>

                    <Button variant='contained' onClick={() => setAdd(true)}>Ajouter</Button>
                </> 
                :
                <DisciplineForm onAdd={tag => handleAdd(tag)} onClose={() => setAdd(false)}/>
            }

        </Stack>

        

        {error && <Alert severity="error">Vous êtes déconnecté. Les données n'ont pas pu être récupérées.</Alert>}

            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><b>Mot clé</b></TableCell>
                            <TableCell><b>Catégorie</b></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {list.slice(0, limit).map(i => 
                            <TableRow key={i.id || Math.random()}>
                                <TableCell>
                                    <Stack direction='row' alignItems='center'>
                                        <Chip color={i.color} size={16} opacity={0.7} style={{marginRight: 16}}/>
                                        <span>{i.title}</span>
                                    </Stack>
                                </TableCell>
                                <TableCell>{i.type?.title}</TableCell>
                                <TableCell>
                                    <Stack direction='row' justifyContent='end'>
                                        <Link to={'/admin/tags/' + i.id}>
                                            <Tip type='edit'/>
                                        </Link>
                                        {i.type?.id === 'discipline' && 
                                            <Tip type='delete' onClick={() => setDeleteConfirm(i.id)}/>
                                        }       
                                    </Stack>
                                </TableCell>
                            </TableRow>    
                        )}

                    </TableBody>
                </Table>
            </TableContainer>

        {items && list.length > limit &&
            <Button onClick={() => setLimit(limit + step)}>Afficher la suite</Button>
        }


        {!items && <Stack direction='row' justifyContent='center' style={{margin: 20}}>
            <CircularProgress size={24} />
        </Stack>}

        <Confirm open={deleteConfirm ? true : false} onClose={() => setDeleteConfirm(false)} onConfirm={handleDelete}>
            Êtes-vous sûr de vouloir supprimer ce mot clé ?    
        </Confirm>

    </Layout>
}

